import { getTextContent } from './get-text-content';
export function getPageProperty(propertyName, block, recordMap) {
    var _a;
    if (!block.properties || !Object.keys(recordMap.collection)) {
        // console.warn(
        //   `block ${block.id} has no properties or this recordMap has no collection record`
        // )
        return null;
    }
    var collection = (_a = recordMap.collection[block.parent_id]) === null || _a === void 0 ? void 0 : _a.value;
    if (collection) {
        var propertyId = Object.keys(collection.schema).find(function (key) { var _a; return ((_a = collection.schema[key]) === null || _a === void 0 ? void 0 : _a.name) === propertyName; });
        if (!propertyId) {
            return null;
        }
        var type = collection.schema[propertyId].type;
        var content = getTextContent(block.properties[propertyId]);
        switch (type) {
            case 'created_time':
                return block.created_time;
            case 'multi_select':
                return content.split(',');
            case 'date': {
                var property = block.properties[propertyId];
                var formatDate = property[0][1][0][1];
                if (formatDate.type == 'datetime') {
                    return new Date("".concat(formatDate.start_date, " ").concat(formatDate.start_time)).getTime();
                }
                else if (formatDate.type == 'date') {
                    return new Date(formatDate.start_date).getTime();
                }
                else if (formatDate.type == 'datetimerange') {
                    var start_date = formatDate.start_date, start_time = formatDate.start_time, end_date = formatDate.end_date, end_time = formatDate.end_time;
                    var startTime = new Date("".concat(start_date, " ").concat(start_time)).getTime();
                    var endTime = new Date("".concat(end_date, " ").concat(end_time)).getTime();
                    return [startTime, endTime];
                }
                else {
                    var startTime = new Date(formatDate.start_date).getTime();
                    var endTime = new Date(formatDate.end_date).getTime();
                    return [startTime, endTime];
                }
            }
            case 'checkbox':
                return content == 'Yes';
            case 'last_edited_time':
                return block.last_edited_time;
            default:
                return content;
        }
    }
    return null;
}
//# sourceMappingURL=get-page-property.js.map